import(/* webpackMode: "eager" */ "/usr/src/next-app/src/app/error.tsx");
